import {ON_RESOLUTION_CHANGE} from '../constants/actionTypes';

export function onResolutionChange(params: {width: number; height: number}) {
    return {
        type: ON_RESOLUTION_CHANGE,
        ...params,
    };
}
